export class Json {
    static absCall(url, body, sendCookies, timeout) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const onLoad = () => {
                /*                   */
                if (req.readyState == XMLHttpRequest.DONE) {
                    /**
 *
 *
 */
                    if (req.status >= 200 && req.status < 300) {
                        let response = req.response;
                        if (typeof response === 'string') {
                            try {
                                response = JSON.parse(response);
                            }
                            catch (e) { }
                        }
                        resolve(response);
                    }
                    else {
                        reject(new Error(`HTTP Status: ${req.status} response type: ${req.responseType}`));
                    }
                }
            };
            const onError = () => {
                reject(new Error('error'));
            };
            const onAbort = () => {
                reject(new Error('aborted'));
            };
            const onTimeout = () => {
                reject(new Error('Timeout ' + timeout + 'ms ' + url));
            };
            req.withCredentials = sendCookies;
            req.addEventListener('load', onLoad);
            req.addEventListener('error', onError);
            req.addEventListener('abort', onAbort);
            if (body === null) {
                req.open('GET', url, true);
            }
            else {
                req.open('POST', url, true);
            }
            req.responseType = 'json';
            /*                                          */
            req.timeout = timeout;
            req.ontimeout = onTimeout;
            req.send(body);
        });
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    static post(url, body, sendCookies = false, timeout = 0) {
        return this.absCall(url, JSON.stringify(body), sendCookies, timeout);
    }
    /**
 *
 *
 *
 *
 *
 */
    static fetch(url, sendCookies = false, timeout = 0) {
        return this.absCall(url, null, sendCookies, timeout);
    }
}
